import { type SystemUserQueryLinkerSchema } from '@/_pages/system-users/shared';
import type { TeamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';

export type PickerComboboxProps = {
  disabled?: boolean;
  className?: string;
  autoFocus?: boolean;
};

export type PickerOptionType = TeamMemberQueryLinkerSchema | SystemUserQueryLinkerSchema;

export type PickerGroupedOption = {
  label: string;
  options: PickerOptionType[];
};

export function isTeamMember(option: PickerOptionType): option is TeamMemberQueryLinkerSchema {
  return 'profile_image' in option;
}

export function isUser(option: PickerOptionType): option is SystemUserQueryLinkerSchema {
  return 'profile_images' in option;
}

export const getLogo = (
  provider: SystemUserQueryLinkerSchema | TeamMemberQueryLinkerSchema | null | undefined
): string => {
  let src: string | undefined = '';
  if (provider) {
    if (isTeamMember(provider)) {
      src = provider?.profile_image?.at(0)?.url;
    }
    if (isUser(provider)) {
      src = provider?.profile_images?.at(0)?.url;
    }
  }
  return src ?? '';
};
